// src/components/Navbar/Navbar.styles.js

// Import only the Material-UI components needed for styling purposes
import { styled } from '@mui/system';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';

// --- THEME COLORS ---
export const colors = {
    navbarBackground: 'rgba(17, 17, 17, 0.95)',
    navbarBackground2: 'rgba(13, 34, 80, 0.95)',
    navbarBackground3: 'rgba(15, 15, 37, 0.95)',
    //navbarBackground4: 'rgba(25, 171, 240,0.90)',
    navbarBackground5: 'rgba(0, 20, 30, 0.98)',
    
    
    drawerBackground: 'rgba(25, 25, 25, 0.98)',
    textColor: '#ffffff',
    accentColor: '#19abf0',
    iconColor: '#ffffff',
};









// --- FIX FOR 'scrolled' WARNING ---
export const StyledAppBar = styled(AppBar, {
    // This function tells styled-components which props to NOT forward to the DOM element.
    shouldForwardProp: (prop) => prop !== 'scrolled'
  })(({ scrolled }) => ({
      background: colors.navbarBackground5,
      borderRadius: '0px',

      // boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.5)',
      // boxShadow: '0px 2px 5px rgba(255,255,255, 0.5)',

      //boxShadow: '0px 2px 5px rgba(255,255,255, 0.3)',
    //  boxShadow: '0px 2px 15px rgba(100,100,100, 0.7)',





    // NEW: Inset shadow to create a soft, blurred top edge
    // This creates a soft, almost glowing effect on the inside of the top border
    // The negative Y-offset (-10px) pushes the shadow up, making it only visible on the top inside edge
    //boxShadow: '0px 2px 15px rgba(100,100,100, 0.7), inset 0 2px 15px 0px rgba(100, 100, 100, 0.03)',

    // boxShadow: '0px 10px 15px rgba(0,20,30, 1), inset 0 2px 15px 0px rgba(0, 20, 30, 0.03)',

  //  boxShadow: '0px 5px 15px rgba(0,60,90, 0.6), inset 0 2px 15px 0px rgba(0, 20, 30, 0.03)',

  boxShadow: '0px 3px 5px rgba(0,20,30, 0.9), inset 0 2px 15px 0px rgba(0, 20, 30, 0.03)',


      opacity: scrolled ? 1 : 0,
      transform: scrolled ? 'translateY(0)' : 'translateY(-100%)',
      pointerEvents: scrolled ? 'auto' : 'none',
      transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
      zIndex: 1100,
       opacity: '95%' // THIS IS THE MAIN APPBAR BACKGROUND SETTING
  }));




// --- STYLED COMPONENTS ---
// export const StyledAppBar = styled(AppBar)(({ scrolled }) => ({
//     background: colors.navbarBackground,
//     borderRadius: '0px',
//     boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.5)',
//     opacity: scrolled ? 1 : 0,
//     transform: scrolled ? 'translateY(0)' : 'translateY(-100%)',
//     pointerEvents: scrolled ? 'auto' : 'none',
//     transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
//     zIndex: 1100,
// }));













export const NavbarContentBox = styled(Box)({
    // padding: '0 20px',
    padding: '0 5px',
    height: '4rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export const StyledLogoContainer = styled('div')({
    padding: '0.5rem',
    margin: '0rem',
    // backgroundColor: 'transparent',
    width: "auto", // Ensure this is flexible
    maxWidth:'300px',
    height: "100%",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const StyledMenuIconButton = styled(IconButton)({
    color: colors.iconColor,
    '&:hover': {
        color: colors.accentColor,
    },
});

export const StyledBox = (props) => (
    <Box
        sx={{
            background: colors.drawerBackground,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '20px',
            boxSizing: 'border-box',
        }}
    >
        {props.children}
    </Box>
);

export const StyledCloseIcon = () => (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <CloseIcon
            sx={{
                width: '3rem',
                height: '3rem',
                color: colors.iconColor,
                '&:hover': {
                    color: colors.accentColor,
                },
            }}
        />
    </div>
);

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
    '& .MuiPaper-root': {
        opacity: 0.95,
        backgroundColor: colors.drawerBackground,
        width: '250px',
    },
}));

export const StyledListItem = (props) => (
    <ListItem
        sx={{
            marginBottom: '0.5rem',
            justifyContent: 'center',
            padding: '5px 0',
        }}
    >
        {props.children}
    </ListItem>
);